var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"method"},[_c('IconComponent',{attrs:{"name":_vm.icon}}),_c('span',{staticClass:"method__title"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('span',{staticClass:"method__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }